import { render, staticRenderFns } from "./VehiclePhotoEditModal.vue?vue&type=template&id=472d7ff8&"
import script from "./VehiclePhotoEditModal.vue?vue&type=script&lang=js&"
export * from "./VehiclePhotoEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports